import React, { useState, useEffect } from "react";
import "./styles/App.css";
import MaterialTable from '@material-table/core';
import axios from "axios";
import {
  Modal,
  TextField,
  Button,
  Typography,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";

import ViewColumn from "@material-ui/icons/ViewColumn";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import { useNavigate } from "react-router-dom";
import IconosEstado from "../Contrato/IconosEstado";

// import SearchBar from "material-ui-search-bar";
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const columns = [
  { title: "Nr. Contrato", field: "nombre", sorting: false, filtering: false },
  {
    title: "Fecha de inicio",
    field: "fechainicio",
    sorting: false,
    filtering: false,
  },
  {
    title: "Fecha de termino",
    field: "fechatermino",
    sorting: false,
    filtering: false,
  },
  {
    title: "Nr. Personas",
    field: "nr_personas",
    sorting: false,
    filtering: false,
  },
  { title: "Operacion", field: "operacion", sorting: false, filtering: false },
  { title: "Estado", field: "estado", sorting: false, filtering: false },
  // {title: 'Detalles', field: 'detalles', sorting: false, filtering: false},
];
const baseUrl = "https://localhost:44312/api/contratos";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "relative",
    textAlign: "center",
    alignItems: "center",
    width: 300,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "13px",
  },
  iconos: {
    cursor: "pointer",
  },
  inputMaterial: {
    width: "100%",
  },
  inputMaterial1: {
    fontWeight: "bold",
  },
  tabla: {
    borderRadius: "10px",
  },
  titulo_modal: {
    fontWeight: "bold",
    color: "black",
    textAlign: "center",
  },

  button: {
    margin: theme.spacing(5, 3, -1),
    width: "260px",
    borderRadius: "9px",
  },
  subtitulos: {
    fontWeight: "bold",
    marginTop: "17px",
    paddingTop: "-10px",
    textAlign: "left",
  },
  dataraw: {
    paddingLeft: "94px",
    fontWeight: "bold",
    fontSize: "15px",
    paddingTop: "10px",
  },
  dataraw1: {
    fontSize: "16px",
    textAlign: "center",
  },
  dataraw2: {
    paddingLeft: "65px",
  }
}));

function CajaDashboard(props) {
  const navigate = useNavigate();
  const styles = useStyles();
  const [data, setData] = useState([]);
  const [modalInsertar, setModalInsertar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalDetalle, setModalDetalle] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [contratoSeleccionado, setContratoSeleccionado] = useState({
    id: "",
    nombre: "",
    fechainicio: "",
    fechatermino: "",
    nr_personas: "",
    operacion: "",
    estado: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setContratoSeleccionado((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const peticionGet = async () => {
    await axios
      .get(baseUrl)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const peticionPost = async () => {
    await axios
      .post(baseUrl, contratoSeleccionado)
      .then((response) => {
        setData(data.concat(response.data));
        abrirCerrarModalInsertar();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const peticionPut = async () => {
    await axios
      .put(baseUrl + "/" + contratoSeleccionado.id, contratoSeleccionado)
      .then((response) => {
        var dataNueva = data;
        dataNueva.map((contrato) => {
          if (contrato.id === contratoSeleccionado.id) {
            contrato.nombre = contratoSeleccionado.nombre;
            contrato.fechainicio = contratoSeleccionado.fechainicio;
            contrato.fechatermino = contratoSeleccionado.fechatermino;
            contrato.nr_personas = contratoSeleccionado.nr_personas;
            contrato.operacion = contratoSeleccionado.operacion;
            contrato.estado = contratoSeleccionado.estado;
          }
        });
        setData(dataNueva);
        abrirCerrarModalEditar();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const peticionDelete = async () => {
    await axios
      .delete(baseUrl + "/" + contratoSeleccionado.id)
      .then((response) => {
        setData(
          data.filter((contrato) => contrato.id !== contratoSeleccionado.id)
        );
        abrirCerrarModalEliminar();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const seleccionarContrato = (contrato, caso) => {
    setContratoSeleccionado(contrato);
    if (caso === "Editar") {
      abrirCerrarModalEditar();
    } else if (caso === "Detalles") {
      abrirCerrarModalDetalle();
    } else if (caso === "Eliminar") {
      abrirCerrarModalEliminar();
    }
  };

  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };

  const abrirCerrarModalEditar = () => {
    setModalEditar(!modalEditar);
  };

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };

  const abrirCerrarModalDetalle = () => {
    setModalDetalle(!modalDetalle);
  };
  const routeChange = () => {
    navigate("/auth/contratos/registrarhrspersona");
  };

  useEffect(() => {
    peticionGet();
  }, []);
  const bodyInsertar = (
    <div className={styles.modal}>
      <h3>Agregar Nuevo Contrato</h3>
      <TextField
        className={styles.inputMaterial}
        label="Nr. Contrato"
        name="nombre"
        onChange={handleChange}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Fecha de inicio"
        name="fechainicio"
        onChange={handleChange}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Fecha de termino"
        name="fechatermino"
        onChange={handleChange}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Nr. personas"
        name="nr_personas"
        onChange={handleChange}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Operacion"
        name="operacion"
        onChange={handleChange}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Estado"
        name="estado"
        onChange={handleChange}
      />
      <br />
      <br />
      <div align="right">
        <Button color="primary" onClick={() => peticionPost()}>
          Insertar
        </Button>
        <Button onClick={() => abrirCerrarModalInsertar()}>Cancelar</Button>
      </div>
    </div>
  );

  const bodyEditar = (
    <div className={styles.modal}>
      <Typography variant="h6" className={styles.titulo_modal}>
        Editar Registro
      </Typography>
      <TextField
        className={styles.inputMaterial}
        name="nombre"
        onChange={handleChange}
        value={contratoSeleccionado && contratoSeleccionado.nombre}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Fecha de inicio"
        name="fechainicio"
        onChange={handleChange}
        value={contratoSeleccionado && contratoSeleccionado.fechainicio}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Fecha de termino"
        name="fechatermino"
        onChange={handleChange}
        value={contratoSeleccionado && contratoSeleccionado.fechatermino}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Nr. personas"
        name="nr_personas"
        onChange={handleChange}
        value={contratoSeleccionado && contratoSeleccionado.nr_personas}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Operacion"
        name="operacion"
        onChange={handleChange}
        value={contratoSeleccionado && contratoSeleccionado.operacion}
      />
      <br />
      <TextField
        className={styles.inputMaterial}
        label="Estado"
        name="estado"
        onChange={handleChange}
        value={contratoSeleccionado && contratoSeleccionado.estado}
      />
      <br />
      <br />
      <div align="right">
        <Button color="primary" onClick={() => peticionPut()}>
          Editar
        </Button>
        <Button onClick={() => abrirCerrarModalEditar()}>Cancelar</Button>
      </div>
    </div>
  );
  const bodyDetalle = (
    <div className={styles.modal}>
      <Grid container>
        <Grid item xs={10} style={{ display: "flex", gap: "2rem" }}>
          <Typography
            variant="body2"
            gutterBottom
            className={styles.subtitulos}
          >
            CONTRATO:
          </Typography>
          <TextField
            id="outlined-read-only-input"
            InputProps={{
              readOnly: true,
            }}
            className={styles.inputMaterial1}
            name="nombre"
            onChange={handleChange}
            value={contratoSeleccionado && contratoSeleccionado.nombre}
          />
        </Grid>
        <br />
        <Grid item xs={10} style={{ display: "flex", gap: "3rem" }}>
          <Typography variant="body2" className={styles.subtitulos}>
            ESTADO:
          </Typography>
          <TextField
            InputProps={{
              readOnly: true,
            }}
            className={styles.inputMaterial}
            name="estado"
            onChange={handleChange}
            value={contratoSeleccionado && contratoSeleccionado.estado}
          />
        </Grid>

        <br />
        <Grid item xs={10} style={{ display: "flex", gap: "3rem" }}>
          <Typography variant="body2" className={styles.subtitulos}>
            Fecha de inicio:
          </Typography>
          <TextField
            id="outlined-read-only-input"
            InputProps={{
              readOnly: true,
            }}
            className={styles.inputMaterial}
            name="fechainicio"
            onChange={handleChange}
            value={contratoSeleccionado && contratoSeleccionado.fechainicio}
          />
        </Grid>
        <br />
        <Grid item xs={10} style={{ display: "flex", gap: "3rem" }}>
          <Typography variant="body2" className={styles.subtitulos}>
            Fecha de termino:
          </Typography>
          <TextField
            id="outlined-read-only-input"
            InputProps={{
              readOnly: true,
            }}
            className={styles.inputMaterial}
            name="fechatermino"
            onChange={handleChange}
            value={contratoSeleccionado && contratoSeleccionado.fechatermino}
          />
        </Grid>
        <br />
        <Grid item xs={10} style={{ display: "flex", gap: "2rem" }}>
          <Typography variant="body2" className={styles.subtitulos}>
            Personas asignadas:
          </Typography>
          <TextField
            fullWidth
            id="outlined-read-only-input"
            InputProps={{
              readOnly: true,
            }}
            className={styles.inputMaterial}
            name="nr_personas"
            onChange={handleChange}
            value={contratoSeleccionado && contratoSeleccionado.nr_personas}
          />
        </Grid>
        <br />
        <Grid item xs={10} style={{ display: "flex", gap: "2.5rem" }}>
          <Typography variant="body2" className={styles.subtitulos}>
            Operacion:
          </Typography>
          <TextField
            id="outlined-read-only-input"
            InputProps={{
              readOnly: true,
            }}
            className={styles.inputMaterial}
            name="operacion"
            onChange={handleChange}
            value={contratoSeleccionado && contratoSeleccionado.operacion}
          />
        </Grid>
        <br />
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          className={styles.dataraw}
        >
          Descripcion:
        </Typography>
        <br />
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          className={styles.dataraw1}
        >
          Descripcion de los servicios que presta este contrato.
        </Typography>
        <br />
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          className={styles.dataraw}
        >
          Subcontratacion:
        </Typography>
        <br />
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          className={styles.dataraw}
        >
          Empresa.
        </Typography>
        <br />
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          className={styles.dataraw2}
        >
          Nombre empresa 1
        </Typography>
        <br />
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          className={styles.dataraw2}
        >
          Nombre empresa 2
        </Typography>

        <div align="right">
          <Button
            type="submit"
            variant="contained"
            onClick={routeChange}
            color="primary"
            className={styles.button}
          >
            REGISTRAR HORAS PERSONA
          </Button>
        </div>
      </Grid>
    </div>
  );

  const bodyEliminar = (
    <div className={styles.modal}>
      
        Estás seguro que deseas eliminar al contrato{" "}
        <b>{contratoSeleccionado && contratoSeleccionado.contrato}</b>?{" "}
     
      <div align="right">
        <Button color="secondary" onClick={() => peticionDelete()}>
          Sí
        </Button>
        <Button onClick={() => abrirCerrarModalEliminar()}>No</Button>
      </div>
    </div>
  );

  return (
    <div className="App">
      {/* llamado al componente desde table material */}
      <IconosEstado />
      {/*  */}
      <MaterialTable
        className={styles.tabla}
        title=""
        columns={columns}
        data={data}
        actions={[
          {
            icon: () => <AppRegistrationIcon />,
            tooltip: "Ver detalles",
            onClick: (event, rowData) =>
              seleccionarContrato(rowData, "Detalles"),
          },
          {
            icon: () => <EditIcon />,
            tooltip: "Editar Contrato",
            onClick: (event, rowData) => seleccionarContrato(rowData, "Editar"),
          },
          {
            icon: () => <DeleteOutlineIcon />,
            tooltip: "Eliminar Contrato",
            onClick: (event, rowData) =>
              seleccionarContrato(rowData, "Eliminar"),
          },
        ]}
        options={{
          // sorting: true,

          exportButton: false,
          maxBodyHeight: 500,
          search: true,
          searchFieldAlignment: "left",
          searchAutoFocus: true,
          filtering: true,
          paging: true,
          pageSizeOptions: [2, 5, 10, 20, 25, 50, 100],
          pageSize: 5,
          headerStyle: {
            backgroundColor: "#DD5000",
            color: "#fff",
            fontWeight: "bold",
          },
          actionsColumnIndex: -1,
        }}
        localization={{
          header: {
            actions: "Acciones",
          },
        }}
        icons={tableIcons}
      />

      <Modal open={modalInsertar} onClose={abrirCerrarModalInsertar}>
        {bodyInsertar}
      </Modal>

      <Modal open={modalEditar} onClose={abrirCerrarModalEditar}>
        {bodyEditar}
      </Modal>

      <Modal open={modalEliminar} onClose={abrirCerrarModalEliminar}>
        {bodyEliminar}
      </Modal>

      <Modal open={modalDetalle} onClose={abrirCerrarModalDetalle}>
        {bodyDetalle}
      </Modal>
    </div>
  );
}

export default CajaDashboard;